module.exports = __webpack_public_path__ + "img/stock5.a69d4b1a.png";